export enum AppointmentLinks {
    ResourceAndPeriods = '/pages/resource/main',
    AppointmentStation = '/pages/appointmentManagement/main',
    AppointmentTracking = '/pages/appointmentTracking/main',
    AppointmentReportList = '/pages/reports/main',
    DoctorsCapacity = '/pages/doctorsCapacity/main',
    ResourcesStation = '/pages/resourcesStation/main',
}